import Conclusion from '../ui/Conclusion';
import { connect } from 'react-redux';
import { goBack, completeWizard, submitPassword } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content,
    lobby_url: state.territory.lobby_url
  });

const mapDispatchToProps = dispatch =>
  ({
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       );
    },
    onWizardCompletion(payload) {
       dispatch(
         completeWizard(payload)
       );
    },
    submitPassword(payload){
      dispatch(submitPassword(payload))
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Conclusion);

export default Container;
